// extracted by mini-css-extract-plugin
module.exports = {"main-header-background":"Header_main-header-background__1r8Td","header-content-wrapper":"Header_header-content-wrapper__1LiLB","header-content":"Header_header-content__1ACbX"};